<div class="padding">
  <!-- Container div for everything -->
  @if (repo.resource$ | async; as data) {
    <div>
      <app-bundle-orders-filter></app-bundle-orders-filter>
      <div class="spacer-small"></div>
      <!-- Main orders table -->
      @if (data) {
        <div class="table-container">
          <!-- Conditional paginator at the top (show only when number of orders displayed is >= 50) -->
          @if (data.length >= 50) {
            <div>
              <mat-paginator [pageSize]="this.repo.pageSize$ | async" [length]="this.repo.resourceCount$ | async"
                [pageIndex]="this.repo.pageNum$ | async" [pageSizeOptions]="[10, 25, 50, 100]"
              showFirstLastButtons="true" (page)="page($event)"></mat-paginator>
              <div class="spacer-small"></div>
            </div>
          }
          <!-- End of conditional paginator at the top -->
          <!-- Orders table -->
          @if (data.length > 0) {
            <table mat-table matSort [dataSource]="data" multiTemplateDataRows class="mat-elevation-z0"
              (matSortChange)="sort($event)">
              <ng-container matColumnDef="referenceNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header id="referenceNumber"> {{ 'common.labels.refNo' | transloco }}
                </th>
                <td mat-cell *matCellDef="let order"> {{order.referenceNumber}} </td>
              </ng-container>
              <ng-container matColumnDef="orderTypeID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header id="orderTypeID"> {{ 'common.labels.type' | transloco }} </th>
                <td mat-cell *matCellDef="let order"> {{ order.orderTypeID | enumLabel:'orderType':order.orderType.name }} </td>
              </ng-container>
              <ng-container matColumnDef="orderStatusTypeID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header id="orderStatusTypeID"> {{ 'common.labels.status' | transloco }}
                </th>
                <td mat-cell *matCellDef="let order"> {{ order.orderStatusTypeID | enumLabel:'orderStatusType' }} </td>
              </ng-container>
              <ng-container matColumnDef="country">
                <th mat-header-cell *matHeaderCellDef mat-sort-header id="country"> {{ 'common.labels.country' | transloco }} </th>
                <td mat-cell *matCellDef="let order"> {{order.country}} </td>
              </ng-container>
              <ng-container matColumnDef="jurisdiction">
                <th mat-header-cell *matHeaderCellDef mat-sort-header id="jurisdiction"> {{ 'common.labels.jurisdiction' | transloco }}
                </th>
                <td mat-cell *matCellDef="let order">{{ order.displayJurisdiction }}
                  <td>
                  </ng-container>
                  <ng-container matColumnDef="dateRequested">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header id="dateRequested"> {{ 'common.labels.dateRequested' | transloco }}
                    </th>
                    <td mat-cell *matCellDef="let order"> {{order.dateRequested | localizedDate
                      }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="view">
                    <th mat-header-cell *matHeaderCellDef [attr.aria-label]="'common.labels.rowActions' | transloco">&nbsp;</th>
                    <td mat-cell *matCellDef="let order">
                      <button mat-icon-button color="accent" (click)="viewOrder(order, false)"
                        [attr.aria-label]="'common.labels.viewOrder' | transloco">
                        <mat-icon>article</mat-icon>
                      </button>
                      <button mat-icon-button color="accent" (click)="viewOrder(order, true)" [attr.aria-label]="'common.labels.viewOrderInNewTab' | transloco">
                        <mat-icon>open_in_new</mat-icon>
                      </button>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="indicator">
                    <th mat-header-cell *matHeaderCellDef id="indicator"></th>
                    <td mat-cell *matCellDef="let order">
                      <lib-disclosure-indicator [isExpanded]="order == _expandedOrder"></lib-disclosure-indicator>
                    </td>
                  </ng-container>
                  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                  <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let order" [attr.colspan]="columnsToDisplayWithView.length">
                      <div class="expanded-entity-detail"
                        [@detailExpand]="order == _expandedOrder ? 'expanded' : 'collapsed'">
                        <div class="expanded-entity-information">
                          <lib-order-preview-host [order]="order"></lib-order-preview-host>
                        </div>
                      </div>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithView"></tr>
                  <tr mat-row *matRowDef="let order; columns: columnsToDisplayWithView;" class="expandable-table-row"
                    [class.example-expanded-row]="_expandedOrder === order"
                    (click)="_expandedOrder = _expandedOrder === order ? null : order" tabindex="0" (keydown.enter)="_expandedOrder = _expandedOrder === order ? null : order">
                  </tr>
                  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expandable-detail-row">
                  </tr>
                </table>
              }
              <!-- End of orders table-->
              <!-- Message while loading (show only if data.length is 0 and loading) -->
              @if (((this.repo.loading$ | async) ?? false) && data.length === 0) {
                <div class="padding center padding-top-bottom-50"
                  >
                  &nbsp;
                </div>
              }
              <!-- Paginator for the bottom -->
              <div class="spacer-small"></div>
              @if (data.length > 0) {
                <mat-paginator [pageSize]="this.repo.pageSize$ | async"
                  [length]="this.repo.resourceCount$ | async" [pageIndex]="this.repo.pageNum$ | async"
                [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons="true" (page)="page($event)"></mat-paginator>
              }
              <!-- End of paginator for the bottom -->
            </div>
          }
          <!-- End of main orders table-->
          <!-- Spinner (shows over entire card) -->
          @if (repo.loading$ | async) {
            <div class="loading-spinner-overlay">
              <mat-spinner></mat-spinner>
            </div>
          }
          <!-- End of spinner -->
          <lib-list-issue [repo]="this.repo" [data]="data"></lib-list-issue>
        </div>
      }
      <!-- End of container div for everything -->
    </div>